import { render, staticRenderFns } from "./Hello.vue?vue&type=template&id=0dfca54b&"
import script from "./Hello.vue?vue&type=script&lang=js&"
export * from "./Hello.vue?vue&type=script&lang=js&"
import style0 from "./Hello.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports